import type { SnackBlocksFormModelContentsMethodsType } from "@/components/features/snack/snack/settings/model/usecase/use-create-snack-layout-settings-form-model/methods/contents";

import { Dialog, DialogClose, DialogContent, DialogTitle } from "@/components/ui/dialog/dialog";
import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

import type { ComponentProps } from "react";

type Props = {
	open: ComponentProps<typeof Dialog>["open"];
	handleOpenChange: ComponentProps<typeof Dialog>["onOpenChange"];

	handleClickCloseButton: ComponentProps<typeof DialogClose>["onClick"];

	onSetBlockTitle: ({ title }: { title: string }) => void;
	title: SnackBlocksFormModelContentsMethodsType["blocks"]["value"][number]["title"];
};

export const DialogBlockTitleSettings = ({
	open,
	handleOpenChange,
	handleClickCloseButton,
	onSetBlockTitle,
	title,
}: Props) => {
	return (
		<Dialog open={open} onOpenChange={handleOpenChange}>
			<DialogClose onClick={handleClickCloseButton} />

			<DialogContent>
				<DialogTitle>タイトル設定</DialogTitle>

				<div className="my-10">
					<InputTextField
						value={title?.value}
						errorMessage={title?.error}
						handleChange={(input) => onSetBlockTitle({ title: input })}
					/>
				</div>
			</DialogContent>
		</Dialog>
	);
};

DialogBlockTitleSettings.displayName = "title";
